import AssistantMessageBubble from './assistant-message-bubble';
import UserMessageBubble from './user-message-bubble';

export interface Bubble {
  from: 'user' | 'assistant';
  text: string;
  isError?: boolean;
}

/** Picks the variant of bubble for who the message is from. */
export default function MessageBubble({ from, text, isError }: Bubble) {
  return from === 'user' ? (
    <UserMessageBubble text={text} />
  ) : (
    <AssistantMessageBubble text={text} isError={isError} />
  );
}
